<div class="row" *ngIf="showCommonItems$ | async">
    <div class="col-12">
        <mat-card class="m-3 p-3">
            <div class="items-bar">
                <mat-form-field appearance="outline" class="search-input">
                    <mat-label>Search items...</mat-label>
                    <input matInput [ngModel]="searchTerm" (ngModelChange)="onSearchTermChange($event)"/>
                </mat-form-field>
                <div class="filters mt-2">
                    <button
                        *ngFor="let f of [{label: 'All', key: 'ALL'}, {label: 'Migrated', key: 'MIGRATED'}, {label: 'Item Group', key: 'ITEM_GROUPING'}, {label: 'Item', key: 'ITEM'}, {label: 'Modifier Group', key: 'MODIFIER_GROUPING'}, {label: 'Modifier', key: 'MODIFIER'}]"
                        (click)="setFilter(f.key)"
                        [class.active]="filter === f.key"
                    >
                        {{ f.label }}
                    </button>
                </div>
                <button
                    *ngIf="sortColumn"
                    class="reset-sort-btn mt-2"
                    (click)="resetSorting()"
                    matTooltip="Reset to default sorting"
                >
                    <mat-icon>clear</mat-icon>
                    Reset Sort
                </button>
                <div class="right mt-2">
                    <button mat-raised-button matTooltip="Creat a new item group, item, modifier group, or modifier"
                            (click)="openCreateCommonItemDialog()" *ngIf="!(hideButtonsToggle$ | async) && isSuperAdmin">
                        <mat-icon style="color: white">add</mat-icon>
                        Create Common Item
                    </button>
                </div>
            </div>

            <div *ngIf="isLoading" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="loading-text">Loading common items...</p>
            </div>

            <div *ngIf="!isLoading" class="table-container">
                <table class="items-table">
                    <thead>
                    <tr>
                        <th>Image</th>
                        <th class="sortable-header" (click)="sortByColumn('tag')">
                            ID/Tag
                            <mat-icon *ngIf="sortColumn === 'tag'" class="sort-icon">
                                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                            </mat-icon>
                        </th>
                        <th class="sortable-header" (click)="sortByColumn('name')">
                            Name
                            <mat-icon *ngIf="sortColumn === 'name'" class="sort-icon">
                                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                            </mat-icon>
                        </th>
                        <th class="sortable-header" (click)="sortByColumn('class')">
                            Class
                            <mat-icon *ngIf="sortColumn === 'class'" class="sort-icon">
                                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                            </mat-icon>
                        </th>
                        <th class="sortable-header" (click)="sortByColumn('type')">
                            Type
                            <mat-icon *ngIf="sortColumn === 'type'" class="sort-icon">
                                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                            </mat-icon>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of (filteredItems$ | async); trackBy: trackByTag" (click)="goToDetail(item)" style="cursor: pointer">
                        <td class="image-col">
                            <img [src]="item.image" alt="{{item.name}}" class="item-image" *ngIf="item.image; else noImage"/>
                            <ng-template #noImage>
                                <img width="37px" height="37px"
                                     src="https://d4gii57lvoht3.cloudfront.net/images/CFA_Circle_Logo.png">
                            </ng-template>
                        </td>
                        <td>{{ item.tag }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.class ?? item.objectType }}</td>
                        <td>{{ item.type }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
    </div>
    <emm-help-button></emm-help-button>
</div>
